import { render, staticRenderFns } from "./BoardAddForm.vue?vue&type=template&id=9e3156ce&"
import script from "./BoardAddForm.vue?vue&type=script&lang=js&"
export * from "./BoardAddForm.vue?vue&type=script&lang=js&"
import style0 from "./BoardAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports